import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DescargaZEForm } from "./form";
const DescargaZEFormRx = componentToRx(DescargaZEForm);
type Entity = models.DescargaZEDTO;
const resource = resources.DescargaZE;
const session = resources.User.SessionRx;
const permisos = resources.User.PermisoRx;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class DescargaZEEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }

    async getValue() {
        if (this.id == "new") {
            return {} as Entity;
        } else {
            return await resource.Get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <DescargaZEFormRx
            value={this.state.value}
            onChange={this.onChange}
            nuevo={this.id == "new"}
        />;
    }
}
export const DescargaZEEdit = withRouter(DescargaZEEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/edit.tsx